export default __webpack_public_path__ + "static/media/odamlar.ec49b47f.svg";